(function () {
  Flint.file('views/pages/mensResiPage.js', function (require) {
    Flint.staticStyles('MensResiPage', {
      '$resiPage': '#_flintapp resiPage.MensResiPage, #_flintapp .MensResiPage.resiPage, #_flintapp .ViewMensResiPage.resiPage, #_flintapp .MensResiPage > .resiPage',
      '$resiForm': '#_flintapp resiForm.MensResiPage, #_flintapp .MensResiPage.resiForm, #_flintapp .ViewMensResiPage.resiForm, #_flintapp .MensResiPage > .resiForm',
      '$submittedSec': '#_flintapp submittedSec.MensResiPage, #_flintapp .MensResiPage.submittedSec, #_flintapp .ViewMensResiPage.submittedSec, #_flintapp .MensResiPage > .submittedSec',
      '$header': '#_flintapp header.MensResiPage, #_flintapp .MensResiPage.header, #_flintapp .ViewMensResiPage.header, #_flintapp .MensResiPage > .header',
      '$ff': '#_flintapp ff.MensResiPage, #_flintapp .MensResiPage.ff, #_flintapp .ViewMensResiPage.ff, #_flintapp .MensResiPage > .ff',
      '$label': '#_flintapp label.MensResiPage, #_flintapp .MensResiPage.label, #_flintapp .ViewMensResiPage.label, #_flintapp .MensResiPage > .label',
      '$row': '#_flintapp row.MensResiPage, #_flintapp .MensResiPage.row, #_flintapp .ViewMensResiPage.row, #_flintapp .MensResiPage > .row',
      '$goButton': '#_flintapp goButton.MensResiPage, #_flintapp .MensResiPage.goButton, #_flintapp .ViewMensResiPage.goButton, #_flintapp .MensResiPage > .goButton',
      '$pleaseFix': '#_flintapp pleaseFix.MensResiPage, #_flintapp .MensResiPage.pleaseFix, #_flintapp .ViewMensResiPage.pleaseFix, #_flintapp .MensResiPage > .pleaseFix'
    }, {
      '$resiPage': {
        padding: [0, 24],
        marginTop: 30,
        marginBottom: 100
      },
      '$resiForm': {
        alignItems: 'stretch'
      },
      '$submittedSec': {
        color: 'green',
        fontWeight: 'bold'
      },
      '$header': {
        color: 'rgb(154, 103, 113)',

        fontWeight: 'bold',
        marginBottom: 30
      },
      '$ff': {
        marginBottom: 20,
        marginRight: 14
      },
      '$label': {
        fontSize: 14
      },
      '$row': {
        flexGrow: 1,
        flexDirection: 'row',
        alignItems: 'stretch'
      },
      '$goButton': {
        marginTop: 20,

        height: 80,

        border: '8px outset rgb(0, 154, 70)',
        borderRadius: 16,
        fontSize: 24,
        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        cursor: 'pointer',
        color: 'black'
      },
      '$pleaseFix': {
        marginTop: 4,
        color: 'red',
        fontWeight: 'bold'
      }
    });
    Flint.view('MensResiPage', function (view, on, $) {
      var context = initContext(view, {
        width: atom()
      });

      var fields = atom(M.records.ResiApp({
        gender: 'male'
      }));
      var highlightingMissingFields = atom(false);
      var submitting = atom(false);
      var submitted = atom(false);

      var ff = function ff(fieldName, label, placeholder, inpStyle) {
        var highlight = highlightingMissingFields.get() && fields.get().get(fieldName) == null;

        return view.el(
          ['label', 1],
          { className: 'ff', key: fieldName },
          label,
          view.el(['TextBox', 1], {
            placeholder: placeholder,
            value: fields.derive(fieldName),
            onChange: function (e) {
              return fields.set(fields.get().set(fieldName, e.value || null));
            },
            inpStyle: IMap({
              marginTop: 4,
              fontSize: context.isMobile.get() ? 14 : 18,
              alignSelf: 'stretch',
              border: highlight ? '1px solid red' : '1px solid #ccc'
            }).merge(inpStyle)
          })
        );
      };

      var submit = function submit() {
        if (submitting.get()) return;

        highlightingMissingFields.set(false);

        var hasMissingField = false;
        fields.get().forEach(function (value, fieldName) {
          if (value == null) {
            hasMissingField = true;
            return false;
          }
        });
        if (hasMissingField) {
          highlightingMissingFields.set(true);
          return;
        }

        submitting.set(true);
        M.apiPost('submitResiApp', {
          params: fields.get().toJS()
        }).then(function () {
          submitting.set(false);
          submitted.set(true);
        }, function (err) {
          submitting.set(false);
          M.util.alertError(err);
        });
      };

      on.mount(function () {
        M.mixpanel.track("PageView", { page: 'mensResi' });
      });view.render(function () {
        return view.el(['NavBar', 1], null);
      });view.render(function () {
        return view.el(
          ['resiPage', 1],
          null,
          view.el(
            ['header', 1],
            null,
            'Men\'s Residential Weekend Application'
          ),
          Flint.iff(submitted.get()) && view.el(
            ['submittedSec', 1],
            { if: submitted.get() },
            view.el(
              ['span', 1],
              null,
              'Thanks for applying, ',
              fields.get().firstName,
              '! We\'ll get back to you within 2 business days.'
            )
          ),
          Flint.iff(!submitted.get()) && view.el(
            ['resiForm', 1],
            { if: !submitted.get() },
            view.el(
              ['row', 1],
              null,
              ff('firstName', null, "First name"),
              ff('lastName', null, "Last name")
            ),
            view.el(
              ['row', 2],
              null,
              ff('city', null, "City"),
              ff('state', null, "State", { width: 100 })
            ),
            ff('phone', "Phone", "(###) ###-####"),
            ff('email', "Email", "john@example.com"),
            ff('freeTime', "How much free time do you have to make this happen?", "Time to devote..."),
            ff('anxiety', "How anxious do you feel meeting women?", "Anxiety..."),
            ff('whyInterested', "Why are you interested in getting this area of your life handled?", "Reason for interest..."),
            ff('formalTraining', "Have you ever had a dating coach or training in pickup?", "Prior formal training..."),
            view.el(
              ['ff', 1],
              null,
              view.el(
                ['label', 2],
                { style: highlightingMissingFields.get() && fields.get().wouldTravel == null ? { color: 'red', fontWeight: 'bold' } : null },
                'Would you travel to LA to get the best training in the world?'
              ),
              view.el(['OptionsPicker', 1], {
                options: [{
                  label: "Yes",
                  value: true
                }, {
                  label: "No",
                  value: false
                }],
                limit: 1,
                onChange: function (e) {
                  fields.set(fields.get().set('wouldTravel', e.selectedValues.get(0)));
                }
              })
            ),
            ff('howMuchWorth', "How much do you think (dollar amount) mastering this skillset is worth?" + " (Please put a realistic amount):", "Reasonable estimate of program value..."),
            view.el(
              ['goButton', 1],
              { onClick: submit },
              Flint.iff(!submitting.get()) && view.el(
                ['submitText', 1],
                { if: !submitting.get() },
                'Submit Application'
              ),
              Flint.iff(submitting.get()) && view.el(['Loader', 1], { if: submitting.get() })
            ),
            Flint.iff(highlightingMissingFields.get()) && view.el(
              ['pleaseFix', 1],
              { if: highlightingMissingFields.get() },
              'Please fix the missing fields.'
            )
          )
        );
      });view.render(function () {
        return view.el(['Footer', 1], null);
      });

      $["resiForm"] = function (_, _index) {
        return {
          width: Math.min(500, context.width.get() - 48) };
      };

      $["header"] = function (_, _index) {
        return { fontSize: Math.max(14, 0.035 * context.width.get()) };
      };

      $["goButton"] = function (_, _index) {
        return { width: Math.min(300, context.width.get() - 48), background: 'linear-gradient(to bottom, ' + 'rgb(0, 227, 61) 0%, rgb(0, 182, 46) 100%)' };
      };
    });
  })
})();
//# sourceMappingURL=mensResiPage.js.map
